import { createContext } from 'react';
import type { PermissionGroup, userRole } from './types';
import { userRoleEnum } from './types';
import type { AgentAuthorityResponse } from '../heyapi';

export const PermissionsContext = createContext<{
  editMode: boolean;
  setEditMode: (arg0: boolean) => void;
  isTravelTime: boolean;
  role: userRole;
  hasPermission: (group: PermissionGroup) => boolean;
  hasExactRole: (exactRole: userRole) => boolean;
  isSystemAdmin: () => boolean;
  responsive?: boolean;
  agentAuthority: AgentAuthorityResponse | undefined;
  refetchAgentAuthority: () => void;
}>({
  editMode: false,
  setEditMode: () => {},
  isTravelTime: false,
  role: userRoleEnum.AGENT,
  hasPermission: () => false,
  hasExactRole: () => false,
  isSystemAdmin: () => false,
  responsive: undefined,
  agentAuthority: undefined,
  refetchAgentAuthority: () => {},
});
